import * as React from 'react';
import Paper from './components/Paper';
import Flipbook from './components/Flipbook';
import Presentation from './components/Presentation';
import PaperMozilla from './components/PaperMozilla';
import PaperReactPdf from './components/PaperReactPdf';


const App = () => {
    const rootDataset = document.getElementById('root').dataset;
    const params = new URLSearchParams(window.location.search);

    // Production: Django injects data-document etc. on the root div.
    // Dev: fall back to URL params (?doc=<url>&type=pdf&dl=false) so the CRA dev
    // server can render a real PDF without the Django backend. Further dev fallback:
    // a public test PDF so ?viewer=reactpdf works without any params.
    const DEV_DEFAULT_PDF =
        'https://mozilla.github.io/pdf.js/web/compressed.tracemonkey-pldi-09.pdf';
    const documentUrl =
        rootDataset.document ||
        params.get('doc') ||
        (process.env.NODE_ENV === 'development' ? DEV_DEFAULT_PDF : undefined);
    const documentType = rootDataset.type || params.get('type') || 'pdf';
    const dlEnabled = rootDataset.dl || params.get('dl') || 'false';
    // printEnabled is independent; if Django doesn't inject it yet, fall back to dlEnabled
    // so existing docs still get print when download is on.
    const printEnabled =
        rootDataset.print || params.get('print') || dlEnabled;
    const showBranding = rootDataset.branding || params.get('branding') || 'false';
    const brandingLink = rootDataset.brandinglink || params.get('brandinglink') || '';

    // Viewer variant switcher. Default for PDF mode is the new react-pdf viewer.
    // ?viewer=current falls back to the old @react-pdf-viewer build, ?viewer=mozilla iframes
    // Mozilla's reference viewer (benchmark only).
    const viewerVariant = params.get('viewer');

    if (documentType === 'flipbook') {
        return <Flipbook documentUrl={documentUrl} dlEnabled={dlEnabled} showBranding={showBranding} brandingLink={brandingLink} />;
    }
    if (documentType === 'presentation') {
        return <Presentation documentUrl={documentUrl} dlEnabled={dlEnabled} showBranding={showBranding} brandingLink={brandingLink} />;
    }
    if (viewerVariant === 'mozilla') {
        return <PaperMozilla documentUrl={documentUrl} dlEnabled={dlEnabled} showBranding={showBranding} brandingLink={brandingLink} />;
    }
    if (viewerVariant === 'current') {
        return <Paper documentUrl={documentUrl} dlEnabled={dlEnabled} showBranding={showBranding} />;
    }
    return (
        <PaperReactPdf
            documentUrl={documentUrl}
            dlEnabled={dlEnabled}
            printEnabled={printEnabled}
            showBranding={showBranding}
            brandingLink={brandingLink}
        />
    );
};

export default App;
